<hlm-dialog
  #dialog
  [closeOnBackdropClick]="false"
  (closed)="onClosed()"
>
  <hlm-dialog-content
    *brnDialogContent="let ctx"
    [showCloseButton]="false"
    class="welcome-dialog p-0! gap-0! w-4xl! max-w-[95vw]! overflow-hidden"
  >
    <div class="flex min-h-128">
      <!-- Left pane: logo + copy + actions -->
      <div class="flex-1 p-10 flex flex-col min-w-0 bg-background">
        <div class="flex items-center gap-3">
          <img src="assets/logo-small.png" alt="Pagai" class="h-8 w-8" />
          <span class="text-lg font-semibold text-foreground">Pagai</span>
        </div>

        <div class="flex-1 flex flex-col justify-center gap-3">
          <h2 hlmDialogTitle class="text-3xl! font-bold! tracking-tight leading-tight">
            Benvenuto in Pagai
          </h2>
          <p hlmDialogDescription class="leading-relaxed max-w-md">
            Inizia subito a esplorare la piattaforma e scopri come funziona Pagai.
          </p>

          <div class="flex flex-wrap items-center gap-3 mt-4">
            <button hlmBtn (click)="onExplore()">Esplora</button>
          </div>
        </div>
      </div>

      <!-- Right pane: spinning euro coin (same Rive animation as login) on solid blue -->
      <div class="relative flex-1 hidden w-full md:flex items-center justify-center bg-[#1071EF] overflow-hidden">
        <app-rive />
        <button
          type="button"
          class="absolute top-4 right-4 inline-flex h-8 w-8 items-center justify-center text-white/60 hover:text-white hover:bg-white/10 rounded-md transition-colors cursor-pointer"
          aria-label="Chiudi"
          (click)="close()"
        >
          <ng-icon name="lucideX" class="h-5 w-5" />
        </button>
      </div>
    </div>
  </hlm-dialog-content>
</hlm-dialog>
